import React from 'react';
import { Text, TextInput, StyleSheet } from 'react-native';
import { commonStyles } from './styles';
import { theme } from '../theme';
import { useNarrowInputFontSize } from '../intakeForm/ResponsiveFormContext';
// https://blog.logrocket.com/react-native-form-validations-with-formik-and-yup/
const CustomInput = (props) => {
    const { field: { name, onBlur, onChange, value }, form: { errors, touched, setFieldTouched }, width, height, multiline, readOnly, formatText, ...inputProps } = props;
    const narrowFontSize = useNarrowInputFontSize();
    const hasError = errors[name] && touched[name];
    let style = [
        localStyles.textInput,
        hasError && localStyles.errorInput,
        { width: width || '100%' },
        { height: height || 36 },
    ];
    if (narrowFontSize) {
        // Phone sign-up only: 16px stops iOS Safari zooming in on focus.
        style.push({ fontSize: narrowFontSize });
    }
    if (readOnly) {
        // disable browser focus ring on web
        style.push({ outline: 'none' });
    }
    return (<>
      <TextInput multiline={multiline} readOnly={readOnly} style={style} value={value} onChangeText={text => onChange(name)(formatText ? formatText(text) : text)} onBlur={() => {
            setFieldTouched(name);
            onBlur(name);
        }} {...inputProps} placeholderTextColor={theme.colors.textQuaternary}/>
      {hasError && <Text style={commonStyles.errorText}>{errors[name]}</Text>}
    </>);
};
const localStyles = StyleSheet.create({
    textInput: {
        margin: 10,
        backgroundColor: theme.colors.surfaceElevated,
        borderColor: theme.colors.controlNeutral,
        borderWidth: StyleSheet.hairlineWidth,
        borderRadius: 10,
        padding: 10,
    },
    errorInput: {
        borderColor: theme.colors.dangerText,
    },
});
export default CustomInput;
